export default __webpack_public_path__ + "search-examples-list-based-search-thumbnail-960-04259caef3fbd117886dbf3bf2fca874.webp";